module.exports = __webpack_public_path__ + "img/1._Bergungsgruppe_ASH.2eff064d.svg";